import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { MlDefault } from './MlDefault';


export class MapLibreTool {

    map;

    createMap = (options) => {

        const opts = { ...MlDefault.map, ...options };

        const myStyle = {
            'id': 'raster',
            'version': 8,
            'name': 'Raster tiles',
            'center': [0, 0],
            'zoom': 0,
            'sources': {
                // 'raster-tiles': {
                //     'type': 'raster',
                //     'tiles': ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
                //     'tileSize': 256,
                //     'minzoom': 0,
                //     'maxzoom': 19
                // },
                // "gis_bina": {
                //     type: 'vector',
                //     "tiles": [
                //         "https://live.basarsoft.com.tr/3dmap_api/Map?z={z}&x={x}&y={y}"
                //         //"http://localhost:5200/WeatherForecast?z={z}&x={x}&y={y}"
                //     ]
                // }
            },
            'layers': [
                // {
                //     'id': 'background',
                //     'type': 'background',
                //     'paint': {
                //         'background-color': '#e0dfdf'
                //     }
                // },
                // {
                //     'id': 'simple-tiles',
                //     'type': 'raster',
                //     'source': 'raster-tiles'
                // },
                // {
                //     'id': 'gis_bina',
                //     'source': 'gis_bina',
                //     'source-layer': 'gis_bina',
                //     'type': 'fill-extrusion',
                //     'minzoom': 13,
                //     'paint': {
                //         'fill-extrusion-color': [
                //             'interpolate',
                //             ['linear'],
                //             ['get', 'toplam_kat_adedi'], 0, 'darkgray', 10, 'royalblue', 20, 'lightblue'
                //         ],
                //         'fill-extrusion-height': [
                //             'interpolate',
                //             ['linear'],
                //             ['zoom'],
                //             13,
                //             0,
                //             16,
                //             ['get', 'toplam_kat_adedi']
                //         ],
                //         'fill-extrusion-base': 0,
                //         'fill-extrusion-opacity': 1
                //     }

                // },
                // {
                //     'id': 'gis_bina2',
                //     'source': 'gis_bina',
                //     'source-layer': 'gis_anahat',
                //     'type': 'line',
                //     'minzoom': 12,
                //     'layout': {
                //         'line-join': 'round',
                //         'line-cap': 'round'
                //     },
                //     'paint': {
                //         'line-color': '#04e030',
                //         'line-width': 3
                //     }
                // },
                // {
                //     'id': 'gis_servis_hatti',
                //     'source': 'gis_bina',
                //     'source-layer': 'gis_servishatti',
                //     'type': 'line',
                //     'minzoom': 13,
                //     'layout': {
                //         'line-join': 'round',
                //         'line-cap': 'round'
                //     },
                //     'paint': {
                //         'line-color': '#c20242',
                //         'line-width': 2
                //     }

                // },
                // {
                //     'id': 'gis_servis_kutu',
                //     'source': 'gis_bina',
                //     'source-layer': 'gis_servis_kutu',
                //     'type': 'fill',
                //     'minzoom': 13,
                //     'paint': {
                //         'fill-color': '#027822',
                //         'fill-opacity': 0.8
                //     }

                // },
                // {
                //     'id': 'gis_vanalar',
                //     'source': 'gis_bina',
                //     'source-layer': 'gis_vanalar',
                //     'type': 'fill',
                //     'minzoom': 13,
                //     'paint': {
                //         'fill-color': '#6f04d9',
                //         'fill-opacity': 0.8
                //     }

                // }
            ]
        };

        this.map = new maplibregl.Map({
            ...{
                container: opts.id,
                style: myStyle
            },
            ...opts
        });

        window.Object.map = this.map;

        return this.map;
    }

    setBingKey = (bingKey) => {

        const bingMaps = [
            {
                id: 'BR',
                url: 'https://dev.virtualearth.net/REST/v1/Imagery/Metadata/' +
                    "Road" + '?uriScheme=https&include=ImageryProviders&key=' + bingKey
            },
            {
                id: 'BS',
                url: 'https://dev.virtualearth.net/REST/v1/Imagery/Metadata/' +
                    "Aerial" + '?uriScheme=https&include=ImageryProviders&key=' + bingKey
            },
            {
                id: 'BP',
                url: 'https://dev.virtualearth.net/REST/v1/Imagery/Metadata/' +
                    "AerialWithLabels" + '?uriScheme=https&include=ImageryProviders&key=' + bingKey

            }];


        for (const element of bingMaps) {

            fetch(element.url).then(r => r.json()).then(r => {

                var tileInfo = r.resourceSets[0].resources[0];

                var tileUrls = [];

                tileInfo.imageUrlSubdomains.forEach(sub => {
                    tileUrls.push(tileInfo.imageUrl.replace('{subdomain}', sub));
                });

                ///todo: 0,ı değil tüm diziyi geçireyim
                baseMaps = [...baseMaps, { ...element, ...{ url: tileUrls[0] } }];
            });
        }


    }

    setGoogleKey = (googleKey) => {

        const googleMaps = [{
            id: 'GR',
            url: 'https://mts0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&apistyle=s.t:2%7Cs.e:l%7Cp.v:off,s.t:20%7Cs.e:l%7Cp.v:off' +
                (googleKey ? "&key=" + googleKey : "")

        },
        {
            id: 'GST',
            url: 'https://mts0.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&apistyle=s.t:0%7Cs.e:l%7Cp.v:off,s.t:20%7Cs.e:l%7Cp.v:off' +
                (googleKey ? "&key=" + googleKey : "")

        },
        {
            id: 'GS',

            url: 'https://mts0.google.com/vt/lyrs=y&x={x}&y={y}&z={z}' +
                (googleKey ? "&key=" + googleKey : "")
        },
        {
            id: 'GP',

            url: 'https://mts0.google.com/vt/lyrs=p&x={x}&y={y}&z={z}' +
                (googleKey ? "&key=" + googleKey : "")

        }];

        baseMaps = [...baseMaps, ...googleMaps];
    }

    setYandexKey = (yandexKey) => {

        const yandexMaps = [{
            id: 'YR',
            url: 'https://core-renderer-tiles.maps.yandex.net/tiles?l=map&v=21.11.09-0-b211103130830&x={x}&y={y}&z={z}&scale=1&lang=tr_TR' +
                (yandexKey ? "&key=" + yandexKey : ""),

        },
        {
            id: 'YU',
            url: 'https://sat01.maps.yandex.net/tiles?l=sat&v=3.249.0&x={x}&y={y}&z={z}&lang=tr_TR' +
                (yandexKey ? "&key=" + yandexKey : ""),
        }];

        baseMaps = [...baseMaps, ...yandexMaps];
    }

    setBmsKey = (bmsKey) => {

        const bmsMaps = [
            {
                id: 'BMS',
                url: `https://bms.basarsoft.com.tr/service/api/v1/map/Default?appcode=${bmsKey.appCode}&accid=${bmsKey.accId}&z={z}&x={x}&y={y}`
            }];

        baseMaps = [...baseMaps, ...bmsMaps];
    }

    addBaseMap = (initialBaseMap = "OSM") => {

        this.map.on('load', () => {

            this.map.addLayer({
                id: MlDefault.baseLayerName,
                type: 'raster',
                source: {
                    id: MlDefault.baseLayerName + "-source",
                    type: "raster",
                    tiles: [baseMaps.find(x => x.id === initialBaseMap).url],
                    tileSize: 256,
                    minzoom: 0,
                    maxzoom: 19
                }
            });
        });
    }

    addDefaultLayers = (layers) => {

        this.map.on('load', () => {

            for (const layer of layers) {

                this.map.addLayer(layer);
            }
        });
    }

    addDefaultSources = (sources) => {

        this.map.on('load', () => {

            for (const source of sources) {

                this.map.addSource(source.id, source);
            }
        });
    }

    findLayer = (name) => this.map.getLayer(name);

    setGlbBaseMap = (selectedBaseMap) => {

        this.changeBaseMap(selectedBaseMap);
    }

    changeBaseMap = (selectedBaseMap) => {

        let baseMapLayer = this.map.getSource(MlDefault.baseLayerName);

        if (baseMapLayer) {

            const baseMap = baseMaps.find(x => x.id === selectedBaseMap);

            const source = baseMap ? baseMap.url : null;

            baseMapLayer.setTiles([source]);

            // baseMapLayer.setSource(source);

            // if (source != null) {

            //     let tileLoading = 0;

            //     let tileLoaded = 0;

            //     let run = 0;

            //     source.on('tileloadstart', x => ++tileLoading);

            //     source.on('tileloadend', x => {

            //         ++tileLoaded;

            //         if (tileLoaded === tileLoading && run <= 0) {

            //             run++;
            //         }
            //     });
            // }
        }
    }


}


let baseMaps = [
    {
        id: 'NONE',
        url: null
    },
    {
        id: 'OR',
        url: 'https://{a-c}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png'
    },
    {
        id: 'OP',
        url: 'https://otile1-s.mqcdn.com/tiles/1.0.0/osm/{z}/{x}/{y}.png'
    },
    {
        id: 'OSM',
        url: 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png'
    }
];
